<my-table
  #table
  key="UserListComponent"
  [defaultColumns]="columns"
  defaultSort="createdAt"
  i18n-paginatorText
  paginatorText="users per page"
  defaultRowsPerPage="10"
  [bulkActions]="bulkActions"
  [dataLoader]="dataLoader"
  columnConfig="true"
  [hasExpandedRow]="hasExpandedRow"
  [inputFilters]="inputFilters"
  searchInput="true"
  >
  <ng-template #totalTitle let-totalRecords>
    <ng-container i18n>{ totalRecords, plural, =0 {No users} =1 {1 user} other {{{ totalRecords | myNumberFormatter }} users}}</ng-container>
  </ng-template>

  <ng-template #captionRight>
    <a class="peertube-create-button" routerLink="/admin/overview/users/create">
      <my-global-icon iconName="user-add" aria-hidden="true"></my-global-icon>
      <ng-container i18n>Create user</ng-container>
    </a>
  </ng-template>

  <ng-template #tableCells let-user>
    @if (table.isColumnDisplayed('username')) {
      <td class="cell-username">
        <a i18n-title title="Open account in a new tab" target="_blank" rel="noopener noreferrer" [routerLink]="[ '/a/' + user.username ]">
          <div class="chip two-lines">
            <my-actor-avatar [actor]="user?.account" actorType="account" size="32"></my-actor-avatar>
            <div>
              <span>{{ user.account.displayName }}</span>
              <span class="muted">{{ user.username }}</span>
            </div>
          </div>
        </a>
        @if (user.accountMutedStatus.mutedByInstance) {
          <div class="pt-badge badge-red" i18n>Muted</div>
        }
        @if (user.blocked) {
          <a routerLink="." [queryParams]="{ blocked: true }" class="pt-badge badge-red" i18n-title title="Filter by banned users" i18n>Banned</a>
        }
      </td>
    }

    @if (table.isColumnDisplayed('role')) {
      <td>
        @if (user.blocked) {
          <a routerLink="." [queryParams]="{ blocked: true }" class="pt-badge badge-banned" i18n-title title="Filter by banned users">{{ user.role.label }}</a>
        } @else {
          <a routerLink="." [queryParams]="{ role: user.role.id }" [title]="getRoleFilterTitle(user.role.label)" class="pt-badge" [ngClass]="getRoleClass(user.role.id)" >{{ user.role.label }}</a>
        }
      </td>
    }

    @if (table.isColumnDisplayed('email')) {
      <td>
        <my-user-email-info [entry]="user" showEmailVerifyInformation="true"></my-user-email-info>
      </td>
    }

    @if (table.isColumnDisplayed('videoQuotaUsed')) {
      <td>
        <my-progress-bar
          i18n-label label="Total video quota" [max]="user.rawVideoQuota" [value]="user.rawVideoQuotaUsed"
          [valueFormatted]="user.videoQuotaUsed" [maxFormatted]="user.videoQuota" size="small"
          >
        </my-progress-bar>
      </td>
    }

    @if (table.isColumnDisplayed('videoQuotaDailyUsed')) {
      <td>
        <my-progress-bar
          i18n-label label="Total daily video quota" [max]="user.rawVideoQuotaDaily" [value]="user.rawVideoQuotaUsedDaily"
          [valueFormatted]="user.videoQuotaUsedDaily" [maxFormatted]="user.videoQuotaDaily" size="small"
          >
        </my-progress-bar>
      </td>
    }

    @if (table.isColumnDisplayed('totalVideoFileSize')) {
      <td>
        {{ user.totalVideoFileSize | bytes }}
      </td>
    }

    @if (table.isColumnDisplayed('twoFactorEnabled')) {
      <td>
        @if (user.twoFactorEnabled) {
          <span i18n i18n-ngbTooltip ngbTooltip="Two factor authentication is enabled" class="pt-badge badge-green">2FA</span>
        }
      </td>
    }

    @if (table.isColumnDisplayed('pluginAuth')) {
      <td>
        @if (user.pluginAuth) {
          <span [ngbTooltip]="user.pluginAuth">{{ user.pluginAuth.replace('peertube-plugin-', '') }}</span>
        }
      </td>
    }

    @if (table.isColumnDisplayed('createdAt')) {
      <td [title]="user.createdAt">{{ user.createdAt | ptDate: 'short' }}</td>
    }

    @if (table.isColumnDisplayed('lastLoginDate')) {
      <td [title]="user.lastLoginDate">
        @if (user.lastLoginDate) {
          {{ user.lastLoginDate | ptDate: 'short' }}
        } @else {
          <span i18n>never</span>
        }
      </td>
    }
  </ng-template>

  <ng-template #actionCell let-user>
    <my-user-moderation-dropdown
      [user]="user" [account]="user.accountMutedStatus" [displayOptions]="userModerationDisplayOptions"
      container="body" (userChanged)="onUserChanged()" (userDeleted)="onUserChanged()"
      >
    </my-user-moderation-dropdown>
  </ng-template>

  <ng-template #expandedRow let-user>
    <span i18n class="ban-reason-label">Ban reason:</span>

    {{ user.blockedReason }}
  </ng-template>
</my-table>

<my-user-ban-modal #userBanModal (userBanned)="onUserChanged()"></my-user-ban-modal>
